import React from "react";
import { NavLink } from "react-router-dom";
import logoImg from "../logo.svg";
import { Icon } from "react-icons-kit";
import { menu } from "react-icons-kit/feather/menu";
import { arrowLeft } from "react-icons-kit/feather/arrowLeft";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { useJwt } from "react-jwt";
import { CreateNotification } from "../apiconfig/authService";
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
// import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
// import * as React from 'react';
// import { useState, useEffect } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
function Addnotification(props) {
    const navigate = useNavigate();
    const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
    if (isExpired) navigate("/");

    const setMediaTableViewMessage = props.setMessage;

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [dateTime, setDateTime] = useState("");
    const [message, setMessage] = useState("");
    const [isMessageRed, setIsMessageRed] = useState("");
    const [value, setValue] = React.useState(dayjs());
    const handleTitleChange = (e) => {
        setTitle(e.target.value);
    };
    const handleDescriptionChange = (e) => {
        setDescription(e.target.value);
    };
    const handledatetimeChange = (e) => {
        // const localDateTime = new Date(e.target.value);
        // const utcISOString = localDateTime.toISOString(); // This gives UTC time
        console.log("e.target.value", e.target.value)
        setDateTime(e.target.value); // Store as UTC
    };
    console.log("dateTime", dateTime)
    const validateInput = () => {
        if (title === "") throw new Error("title is required.");
    };

    const handleSubmitClick = async (e) => {
        e.preventDefault();

        try {
            validateInput();
        } catch (error) {
            setIsMessageRed(true);
            setMessage(error.message);
            window.scrollTo(0, 0);
            return;
        }

        let response;
        const data = {
            "title": title,
            "description": description,
            "selecteddate": value,
        }
        try {
            response = await CreateNotification(
                data,
                localStorage.getItem("accessToken")
            );
            if (response.status === 200) {
                setMediaTableViewMessage(response.data.message);
                navigate("/notification");
            }
        } catch (err) {
            if (err.response && err.response.data && err.response.data.error) {
                setIsMessageRed(true);
                setMessage(err.response.data.error);
                window.scrollTo(0, 0);
            } else {
                setIsMessageRed(true);
                setMessage("An error occurred. Please try again later.");
                window.scrollTo(0, 0);
            }
        }
    };

    const handleChange = (newValue) => {
        const now = dayjs();
        if (newValue && newValue.isBefore(now)) {
            // Ignore or optionally correct to now
            setValue(now);
        } else {
            setValue(newValue);
        }
    };

    const disablePastTime = (date) => {
        const now = dayjs();
        // Disable if date is before now
        return date.isBefore(now);
    };

    return (
        <div className="dashboard-content">
            <Sidebar />
            {/* <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div> */}
            <div className="body-cart tab-content dasContent p-4 bg-white rounded">
                <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
                    <h1 className="heading h4 mb-0 fw-bold">Add Notification</h1>
                    <div className="d-inline-flex gap-2">
                        <NavLink to="/media" className="btn btn-primary">
                            View All
                        </NavLink>
                    </div>
                </div>

                {message && (
                    <div
                        style={{ color: isMessageRed ? "red" : "black" }}
                        className="alert alert-primary"
                        role="alert"
                    >
                        {message}
                    </div>
                )}

                <div
                    role="tabpanel"
                    className="personal-info tab-pane active storetab"
                    id="pi"
                >
                    {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
                    <div className="row">
                        <div className="form-group col-sm-12 col-lg-12 mb-3">
                            <label htmlFor="catName">Title</label>
                            <input
                                type="text"
                                value={title}
                                onChange={handleTitleChange}
                                className="form-control custom-input my-2"
                                id="catName"
                                placeholder="Title"
                            />
                        </div>
                    </div>

                    {/* <label htmlFor="floatingInput">Description</label> */}
                    <div className="row">
                        <div className="form-group col-sm-12 col-lg-12 mb-3">
                            <label htmlFor="catName">Description</label>
                            <input
                                type="text"
                                value={description}
                                onChange={handleDescriptionChange}
                                className="form-control custom-input my-2"
                                id="catName"
                                placeholder="Description"
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-sm-12 col-lg-12 mb-3">
                            <label htmlFor="catName">Date&Time</label>
                            {/* <input
                                type="datetime-local"
                                id="datetime"
                                value={dateTime}
                                className="form-control custom-input my-2"
                                onChange={handledatetimeChange}
                                min={minDateTime}
                            /> */}
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    // label="Date & Time (no past)"
                                    value={value}
                                    className="form-control custom-input my-2"
                                    onChange={handleChange}
                                    minDateTime={dayjs()}
                                    shouldDisableTime={(timeValue, clockType) => {
                                        const now = dayjs();
                                        if (clockType === 'hours') {
                                            return value.isSame(now, 'day') && timeValue < now.hour();
                                        }
                                        if (clockType === 'minutes') {
                                            return value.isSame(now, 'day') && value.hour() === now.hour() && timeValue < now.minute();
                                        }
                                        return false;
                                    }}
                                    disablePast
                                />
                            </LocalizationProvider>
                            {/* <DateTimePicker
                                className="form-control custom-input my-2"
                                onChange={setDateTime}
                                value={dateTime}
                                minDate={minDateTime}  // This only affects date
                                minDateTime={minDateTime} // This ensures past time is blocked
                            /> */}
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-sm-12 col-lg-12 mb-3">
                            <button
                                type="submit"
                                onClick={handleSubmitClick}
                                className="btn btn-primary save-btn text-uppercase px-4 my-3"
                            >
                                Add
                            </button>
                        </div>
                    </div>
                </div>
                <hr />
            </div>
        </div>
    );
}
export default Addnotification;
